import axios from "utils/axios";
import { stringify } from "query-string";

export const getPettyCashSettings = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/pettycashSettings/pagination?${query}`);
};

export const getPettyCashSetting = (id) => {
  return axios.get(`/hr/pettycashSettings/${id}`);
};

export const addPettyCashSetting = (data) => {
  return axios.post(`/hr/pettycashSettings`, data);
};

export const editPettyCashSetting = (data) => {
  return axios.put(`/hr/pettycashSettings/${data?.id}`, data);
};

export const deletePettyCashSetting = (id) => {
  return axios.delete(`/hr/pettycashSettings/${id}`);
};
